var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dept"},[_c('div',[_c('h6',[_vm._v(_vm._s(_vm.dept.name))])]),_c('div',{staticClass:"edit-delete"},[_vm._t("edit-delete")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }